<template>
    <div class="app-logo-container">
        <img class="h-auto max-w-full w-[150px] sm:w-[200px]" :title="$root.app.name" :src="$root.app.logo_url" />
    </div>
</template>

<script>
    export default {

    }
</script>